import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StandorteComponent } from './standorte.component';

const routes: Routes = [
  {
    path: '',
    component: StandorteComponent,
    data: { title: 'Standorte' }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StandorteRoutingModule { }






























